// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"58654bee","703":"ae6f7837"}[chunkId] + ".chunk.js";
};